"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const react_pose_1 = __importDefault(require("react-pose"));
const oxygen_constants_1 = require("@8x8/oxygen-constants");
const oxygen_config_1 = require("@8x8/oxygen-config");
const getColor_1 = __importDefault(require("./utils/getColor"));
const getWidth_1 = __importDefault(require("./utils/getWidth"));
const toastTheme = (0, oxygen_config_1.getById)('toast');
const toastWrapperAnimationProps = {
    enter: {
        opacity: 1,
        transition: {
            duration: toastTheme.animationEnterDuration,
            ease: toastTheme.animationEnterTimingFunction,
        },
    },
    exit: {
        opacity: 0,
        transition: {
            duration: toastTheme.animationExitDuration,
            ease: toastTheme.animationExitTimingFunction,
        },
    },
    flip: {
        transition: {
            type: 'tween',
            duration: toastTheme.animationFlipDuration,
        },
    },
};
const ToastWrapper = (0, styled_components_1.default)(react_pose_1.default.div(toastWrapperAnimationProps)) `
  display: flex;
  box-sizing: border-box;

  background-color: ${({ theme, type }) => {
    if (theme.isClassic &&
        (type === oxygen_constants_1.toastTypes.error || type === oxygen_constants_1.toastTypes.warning)) {
        return theme.backgroundColorError;
    }
    return theme.backgroundColor;
}};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.boxShadow};

  color: ${({ theme }) => (theme.isClassic ? getColor_1.default : theme.colorTitle)};

  font-stretch: ${({ theme }) => theme.fontStretch};
  font-style: ${({ theme }) => theme.fontStyle};
  text-align: ${({ theme }) => theme.textAlign};

  padding: ${({ theme }) => theme.padding};

  width: ${getWidth_1.default};
  max-width: ${({ theme }) => theme.maxWidth};
`;
exports.default = ToastWrapper;
